import { fetchInboxMessages } from "@/lib/api/imap";
import { purgeMailClientCaches } from "@/lib/cache/purgeMailClientCaches";
import { INBOX_BOOTSTRAP_SIZE } from "@/lib/constants/inbox";
import { publishFolderSnapshot } from "@/lib/mail/inboxFolderBus";
import {
  idleDelay,
  isStandardBootstrapFolder,
  sortFoldersForBootstrap,
} from "@/lib/mail/folderWarmup";
import type { MailFolder } from "@/lib/types/mail";

const BG_FOLDER_GAP_MS = 80;

/** Purge caches navigateur pour un compte (headers, corps, flags PJ, bus, IDB). */
export async function clearAccountClientMailCache(accountId: number): Promise<void> {
  await purgeMailClientCaches({ accountId });
}

/** Recharge les en-têtes standard en tâche de fond (silencieux). */
export function reloadStandardFoldersInBackground(
  accountId: number,
  folders: MailFolder[]
): void {
  const targets = sortFoldersForBootstrap(folders).filter((f) =>
    isStandardBootstrapFolder(f.name)
  );

  if (targets.length === 0) {
    return;
  }

  void (async () => {
    for (const folder of targets) {
      const res = await fetchInboxMessages({
        accountId,
        folder: folder.name,
        limit: INBOX_BOOTSTRAP_SIZE,
        offset: 0,
        refresh: true,
      });

      if (res.ok) {
        const batch = res.data.messages ?? [];
        publishFolderSnapshot({
          accountId,
          folder: folder.name,
          messages: batch,
          total: res.data.total ?? batch.length,
          offset: batch.length,
          fromCache: false,
          bootstrapped: true,
        });
      }

      await idleDelay(BG_FOLDER_GAP_MS);
    }
  })();
}
